export class InvalidGrantError extends Error {
  constructor(
    message = 'This page is not currently working, due to a problem accessing one or more of the calendars required. Please try again later.',
  ) {
    super(message)
    this.name = 'InvalidGrantError'
  }
}
